import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getDateRangeTextLong, getTimeRangeText } from '@general/dates';
import colors from '@general/colors';
import EnvelopeIcon from '@icons/EnvelopeIcon';
import PencilIcon from '@icons/PencilIcon';
import TrashIcon from '@icons/TrashIcon';
import { ButtonNoStyles, H4, LabelLarge, LabelSmall, LinkSmall, TagPrimary } from '@styled';

const EventAppointmentCardContainer = styled.div`
    border-bottom: 1px solid ${colors.lightGray};
    padding-bottom: 16px;
    padding-top: 32px;
`;

const Column2 = styled.div`
    padding-right: 32px;
    position: relative;
    width: 80%;
`;

const ActionsContainer = styled.div`
    align-items: center;
    display: flex;
    position: absolute;
    right: 0;
    top: 0;
`;

const ActionButton = styled(ButtonNoStyles)`
    align-items: center;
    display: flex;
    height: 40px;
    justify-content: center;
    width: 40px;

    &:hover {
        background: ${colors.ultraLightGray};
        border-radius: 50%;
    }
`;

const EventAppointmentCard = ({ appointment }) => {
    const { id, type, name, eventSlug, status, startTime, endTime, location } = appointment;

    const history = useHistory();
    const appointmentURL = `/my-icsc/events/${eventSlug}/appointments/${id}`;

    return (
        <EventAppointmentCardContainer className="d-flex">
            <div className="w-1/5">
                <LabelSmall className="d-block mb-2">{getDateRangeTextLong(startTime)}</LabelSmall>

                <LabelSmall className="d-block">{getTimeRangeText(startTime, endTime)}</LabelSmall>
            </div>

            <Column2>
                <LabelLarge className="d-block mb-1 text-primary">{type}</LabelLarge>

                <div className="align-items-center d-flex mb-3">
                    <H4>Appointment with {name}</H4>

                    {status === 'new' && <TagPrimary className="ml-2">New Appointment</TagPrimary>}
                    {status === 'pending' && <TagPrimary className="ml-2">Pending</TagPrimary>}
                </div>

                <LabelSmall className="d-block mb-3">{location}</LabelSmall>
                <LinkSmall
                    href={appointmentURL}
                    onClick={e => {
                        e.preventDefault();
                        history.push(appointmentURL);
                    }}
                >
                    <span>View {name}'s Profile</span>
                </LinkSmall>

                <ActionsContainer>
                    <ActionButton title="Edit Appointment">
                        <PencilIcon />
                    </ActionButton>

                    <ActionButton title="Remove Appointment">
                        <TrashIcon />
                    </ActionButton>

                    <ActionButton title="Email Appointment">
                        <EnvelopeIcon />
                    </ActionButton>
                </ActionsContainer>
            </Column2>
        </EventAppointmentCardContainer>
    );
};

EventAppointmentCard.propTypes = {
    appointment: PropTypes.object.isRequired,
};

export default EventAppointmentCard;
